var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quiz-timer"},[_c('ProgressBar',{attrs:{"width":_vm.percent,"text":_vm.timerText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }